import React from "react";
import svgs, { svgType } from "../../../../assets/svgs";

const mainContainerStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    alignItems: "stretch",
    background: "white",
    borderRadius: 12,
    overflow: "hidden",
    margin: "0 0 16px 0",
    border: "1px solid #DB7C0F",
}

const viewReqStyle = (onViewRequest) => ({
    paddingLeft: 2,
    paddingRight: 2,
    paddingTop: 3,
    paddingBottom: 3,
    background: "none",
    border: "none",
    color: "#004DB2",
    fontSize: 14,
    fontFamily: "MM Sharp Sans, sans-serif",
    fontWeight: 600,
    lineHeight: "14px",
    letterSpacing: 0.25,
    wordWrap: "break-word",
    cursor: onViewRequest ? "pointer" : "default",
});

const viewReqContainerStyle = {
    width: 48,
    minWidth: 48,
    height: "auto",
    paddingLeft: 8,
    paddingRight: 8,
    background: "#DB7C0F",
    borderTopLeftRadius: 8,
    borderBottomLeftRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}

const textContainerStyle = {
    flex: "1 1 0",
    background: "white",
    padding: 16,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    alignItems: "flex-start",
    gap: 8
}

const textStyle = {
    color: "rgba(0, 0, 0, 0.85)",
    fontSize: 16,
    fontFamily: "Lato, sans-serif",
    fontWeight: 400,
    lineHeight: "24px",
    wordWrap: "break-word",
};

const DocRequestWarning = ({ onViewRequest }) => (
  <div style={mainContainerStyle}>
    <div style={viewReqContainerStyle}>
      <div style={{ width: 24, height: 24, position: "relative", overflow: "hidden" }}>
        <div style={{ width: 22, height: 22, left: 1, top: 1, position: "absolute", background: "white", borderRadius: "50%" }}></div>
        <span style={{ position: "absolute", background: "#DB7C0F", left: 0, top: 0, width: 24, height: 24, display: "flex", alignItems: "center", justifyContent: "center" }}>
          {svgs[svgType.warning]}
        </span>
      </div>
    </div>

    <div style={textContainerStyle}>
      <div style={textStyle}>
        Additional documentation is needed to continue processing your application.
      </div>
      <button
        type="button"
        style={viewReqStyle(onViewRequest)}
        onClick={onViewRequest}
      >
        View request
      </button>
    </div>
  </div>
);

export default DocRequestWarning;
